import React, { useState } from 'react';

import { Layout } from './components';
import { DrawGame, Game, Reference } from './pages';
import { GameMode, Pages } from './types';

const ModeSelection = ({ onSelectMode }: { onSelectMode: (mode: GameMode) => void }) => (
  <div className="flex flex-col items-center gap-4">
    <div className="prose mb-2">
      <h2>Select Game Mode</h2>
    </div>

    <div className="flex flex-col items-center gap-2 w-full">
      <div className="prose">
        <h3>Read Braille</h3>
      </div>
      <button className="btn btn-wide" onClick={() => onSelectMode('letters')}>
        Letters
      </button>
      <button className="btn btn-wide" onClick={() => onSelectMode('words')}>
        Words
      </button>
      <button className="btn btn-wide" onClick={() => onSelectMode('numbers-signs')}>
        Numbers & Signs
      </button>
    </div>

    <div className="flex flex-col items-center gap-2 w-full mt-4">
      <div className="prose">
        <h3>Draw Braille</h3>
      </div>
      <button className="btn btn-wide" onClick={() => onSelectMode('draw-letter')}>
        Letter
      </button>
      <button className="btn btn-wide" onClick={() => onSelectMode('draw-word')}>
        Word
      </button>
    </div>
  </div>
);

export const App = () => {
  const [page, setPage] = useState<Pages>(Pages.Game);
  const [gameMode, setGameMode] = useState<GameMode | null>(null);

  const AppWrapper = ({ children }: { children: React.ReactNode }) => (
    <Layout setPage={setPage} page={page}>
      {children}
    </Layout>
  );

  switch (page) {
    case Pages.Reference:
      return (
        <AppWrapper>
          <Reference />
        </AppWrapper>
      );
    case Pages.Game:
    default:
      return (
        <AppWrapper>
          {gameMode === null ? (
            <ModeSelection onSelectMode={setGameMode} />
          ) : gameMode === 'draw-letter' || gameMode === 'draw-word' ? (
            <DrawGame mode={gameMode} onBack={() => setGameMode(null)} />
          ) : (
            <Game mode={gameMode} onBack={() => setGameMode(null)} />
          )}
        </AppWrapper>
      );
  }
};
